var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("处理成功: "+_vm._s(_vm.form.successTotal)+" 条")]),_c('p',[_vm._v("处理失败: "+_vm._s(_vm.form.failTotal)+" 条")]),_vm._l((_vm.form.failMessages),function(x){return _c('p',{key:x},[_vm._v(" "+_vm._s(x)+" ")])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }